import { IsIn, IsInt, IsNotEmpty, IsOptional, IsString, Matches, MaxLength, ValidateNested } from 'class-validator';
import { validationPatterns } from '../../constants';
import { Type } from 'class-transformer';
import { CityCreateDto } from './city-create.dto';
import { CustomerBusinessType } from '../../enum/piecloud-signup';

export class CustomerLeadApproveDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  firstName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  lastName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  @Matches(validationPatterns.email)
  contactEmail: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(20)
  contactPhone: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(2)
  contactPhoneCountryCode: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  brandName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  businessName: string;

  @IsString()
  @IsNotEmpty()
  @IsIn(Object.values(CustomerBusinessType))
  businessType: CustomerBusinessType;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  companyNumber: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => CityCreateDto)
  businessCity: CityCreateDto;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  businessAddress: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  businessAddressLine2?: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(20)
  businessAddressPostCode: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  @Matches(validationPatterns.url)
  businessURL?: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  merchantGroupName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  merchantName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  @Matches(validationPatterns.email)
  merchantEmail: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(20)
  merchantPhone: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(2)
  merchantPhoneCountryCode: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => CityCreateDto)
  merchantCity: CityCreateDto;

  @IsString()
  @IsNotEmpty()
  @MaxLength(150)
  merchantAddress: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(20)
  merchantPostCode: string;

  @IsInt()
  @IsOptional()
  billingProductId?: number;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  billingProductName?: string;

  @IsInt()
  @IsOptional()
  billingPlanId?: number;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  billingPlanName?: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(3)
  currencyCode: string;

  @IsInt()
  @IsNotEmpty()
  transactionPricingPlanId: number;
}